import React, { useRef, useState, useEffect } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { reviewsAPI, statsAPI } from '../services/api';

const Testimonials = () => {
  const scrollRef = useRef(null);
  const [testimonials, setTestimonials] = useState([]);
  const [stats, setStats] = useState({ rating: 4.8 });

  useEffect(() => {
    reviewsAPI.getLatest().then(res => setTestimonials(res.data)).catch(() => {});
    statsAPI.get().then(res => setStats(res.data)).catch(() => {});
  }, []);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === 'left' ? -340 : 340,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-3">
          Un niveau de satisfaction élevé
        </h2>
        <div className="flex items-center justify-center gap-2 mb-10">
          <span className="text-4xl font-bold text-gray-900">{stats.rating}</span>
          <div>
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={16}
                  className={i < Math.floor(stats.rating) ? 'text-yellow-400 fill-yellow-400' : 'text-gray-200 fill-gray-200'}
                />
              ))}
            </div>
            <p className="text-xs text-gray-500 mt-0.5">Note moyenne sur 5 de tous nos prestataires</p>
          </div>
        </div>

        <div className="relative">
          <button
            onClick={() => scroll('left')}
            className="absolute -left-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors hidden md:flex"
          >
            <ChevronLeft size={20} className="text-gray-600" />
          </button>
          <button
            onClick={() => scroll('right')}
            className="absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors hidden md:flex"
          >
            <ChevronRight size={20} className="text-gray-600" />
          </button>

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto pb-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {testimonials.map((t) => (
              <div
                key={t.id}
                className="flex-shrink-0 w-[320px] bg-white border border-gray-100 rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow"
              >
                {/* Provider info */}
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={t.provider_photo || t.providerPhoto}
                    alt={t.provider_name || t.providerName}
                    className="w-11 h-11 rounded-full object-cover"
                  />
                  <div>
                    <h4 className="text-sm font-semibold text-gray-900">{t.provider_name || t.providerName}</h4>
                    <p className="text-xs text-gray-500">{t.provider_skill || t.providerSkill}</p>
                  </div>
                </div>

                {/* Service info */}
                <p className="text-xs text-gray-400 mb-2">
                  {t.service_type || t.serviceType} ({t.service_city || t.serviceCity})
                </p>

                {/* Review text */}
                <p className="text-sm text-gray-700 leading-relaxed mb-3 line-clamp-4">
                  {t.text || t.reviewText}
                </p>

                {/* Reviewer */}
                <p className="text-xs text-gray-400">
                  Par {t.reviewer_name || t.reviewerName}, {t.time_ago || t.timeAgo}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
